import { Dispatch, SetStateAction } from 'react';
import { useLocation } from 'react-router-dom';

import { getHeaderRoutes } from '@/app/providers/router/config';
import { commonRoutes } from '@/app/providers/router/routes';
import { isServiceMode } from '@/app/shared/constants/env';
import { cn } from '@/app/shared/lib/cn';
import { AppLink } from '@/app/shared/ui/AppLink';

export interface NabMenuProps {
  setIsModalOpen?: Dispatch<SetStateAction<boolean>>;
}

export const NavMenu = ({ setIsModalOpen }: NabMenuProps) => {
  const location = useLocation();
  const headerRoutes = getHeaderRoutes();

  return (
    <nav className={cn('flex flex-col xl:flex-row xl:gap-1', isServiceMode && 'pointer-events-none')}>
      {headerRoutes
        .filter((route) => route.path !== '*')
        .map((route) => {
          const isActive =
            route.path === commonRoutes.VAULTS
              ? location.pathname === commonRoutes.VAULTS || location.pathname.startsWith('/market-details')
              : route.path === '/'
                ? location.pathname === '/'
                : location.pathname === route.path || location.pathname.startsWith(`${route.path}/`);

          return (
            <AppLink
              onClick={() => setIsModalOpen?.(false)}
              key={route.path}
              to={route.path}
              className={`rounded-md px-3 py-2.5 xl:rounded-lg xl:px-2.5 xl:py-2 ${
                isActive ? 'bg-gray-800 text-gray-50' : 'text-gray-400 hover:bg-gray-800 hover:text-gray-50'
              }`}
            >
              {route.label}
            </AppLink>
          );
        })}
    </nav>
  );
};
